import isNil from 'lodash/isNil';
import useSingleQuery from '../../../../../../shared/hooks/use-single-query.hook';
import {ComplianceRedFlagConfig} from '../../../../../../shared/model/compliance-red-flag-config.model';
import {COMPLIANCE_RED_FLAG_URL} from '../../../../../../constants/api-urls';

export interface CustomFieldDictionariesState {
  areComplianceRedFlagConfigLoaded: boolean;
  complianceRedFlagConfig?: ComplianceRedFlagConfig[];
}

export default function useComplianceRedFlagConfig(): CustomFieldDictionariesState {

  const complianceRedFlagConfig = useSingleQuery<ComplianceRedFlagConfig[]>(COMPLIANCE_RED_FLAG_URL, null);
  const areComplianceRedFlagConfigLoaded = !isNil(complianceRedFlagConfig);

  return {complianceRedFlagConfig, areComplianceRedFlagConfigLoaded};
}
